import React from 'react';
import {Chip} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {resolveEmrSyncChipStatus} from '../utils/emrSyncChipStatus';

export type EmrSyncChipStatus =
  | 'synced'
  | 'pending'
  | 'needs_attention'
  | 'update_pending'
  | 'awaiting_emr_id'
  | 'none';

export type EmrSyncChipEntityType = 'patient' | 'guarantor' | 'appointment';

type EmrSyncStatusChipProps = {
  hasIntegration?: boolean;
  /** patient/guarantor use updated_in_emr*; appointments only have posted_to_emr */
  entityType?: EmrSyncChipEntityType;
  syncStatus?: EmrSyncChipStatus | string | null;
  postedToEmr?: boolean;
  updatedInEmr?: boolean;
  updatedInEmrBy?: string | number | null;
  updatedInEmrAt?: string | null;
  awaitingEmrId?: boolean;
  jobState?: string | null;
  errorClass?: string | null;
};

export {resolveEmrSyncChipStatus};

const STATUS_COLORS: Record<
  Exclude<EmrSyncChipStatus, 'none'>,
  'default' | 'primary' | 'secondary'
> = {
  synced: 'primary',
  pending: 'default',
  needs_attention: 'secondary',
  update_pending: 'default',
  awaiting_emr_id: 'default'
};

const EmrSyncStatusChip: React.FC<EmrSyncStatusChipProps> = props => {
  const {t} = useTranslation();
  const status = resolveEmrSyncChipStatus(props);

  if (status === 'none') {
    return null;
  }

  const labelKey = `EMR_SYNC.STATUS_CHIP.${status.toUpperCase()}`;

  return (
    <Chip
      size="small"
      color={STATUS_COLORS[status]}
      label={t(labelKey)}
      style={{marginLeft: 4}}
    />
  );
};

export default EmrSyncStatusChip;
